import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../../component/img/logo2.png";

import { Menu, ChevronDown, Headphones, PhoneCall, User, Monitor, Send } from "react-feather";
import profileAvatar from "../../../component/img/avatar.png";
import { useNavigate } from "react-router-dom";

const DistributorReportNavbar = () => {
 


  return (
    <>
      <section className="">
         <div className="mb-2 text-start">
            <Link to="/distributor/flight-report" className="btn3 bhg4 me-2 txt71">Flights Booking Report</Link>
            <Link to="/distributor/hotel-report" className="btn3 bhg4 me-2 txt71">Hotel Booking Report</Link>
            <Link to="/distributor/bus-report" className="btn3 bhg4 me-2 txt71">Bus Booking Report</Link>
            <Link to="/distributor/recharge-report" className="btn3 bhg4 me-2 txt71">Recharge/DTH Report</Link>
         </div>
      </section>
    </>
  );
};

export default DistributorReportNavbar;
